type HeaderProps = {
  smallHeader?: boolean
}

export const LoginHeader = (props: HeaderProps) => {
  const { smallHeader } = props

  return (
    <div className="flex flex-col items-center justify-between">
      {!smallHeader && <h2 className="pb-6 text-2xl">Welcome to</h2>}
      <h1 className="pb-10 text-5xl">Morrisons Supplier Data Hub</h1>
    </div>
  )
}
